import React from "react";
import MainBanner from "../Pricing/MainBanner";
import Footer from "../Common/Footer";

class Pricing extends React.Component {
  render() {
    const inscripciones = [
      {
        title: "ENTRADA CONGRESO",
        subtitle: "1 día, sábado 15",
        price: "40",
        zoho_url:
          "https://zohosecurepay.eu/checkout/5p48jn0d-tygjezlb1q1he/Entrada-Congreso-1-da",
        table_class: "pricingTable-header",
        item1: "Ponencia Carmen Pellicer",
        item2: "Participación en 3 de los 12 talleres.",
        item3: "Café y visita exposición. ",
        item4: "Acto de Clausura y entrega de premios. ",
        item5: "Acreditación. Guardarropa.  ",
        item6: "·",
        item7: "·",
        item8: "·",
      },
      {
        title: "ENTRADA CONGRESO",
        subtitle: "2 días",
        price: "150",
        zoho_url:
          "https://zohosecurepay.eu/checkout/tq85md3y-k5ubzs869o99o/Entrada-Congreso-2-das",
        table_class: "pricingTable-header",
        item1: "Asistencia a las 4 ponencias y 3 mesas redondas.",
        item2: "Participación en 3 de los 12 talleres (sábado).",
        item3: "Café y visita exposición (dos días). ",
        item4: "Acto de Clausura y entrega de premios. ",
        item5: "Acreditación. Guardarropa. Certificado. ",
        item6: "Visita Aulas Vivas (viernes).",
        item7: "Almuerzo y música en directo (viernes). ",
      },
      {
        title: "ENTRADA DE GRUPO",
        subtitle: "Para instituciones educativas",
        price: "",
        zoho_url: "",
        table_class: "pricingTable-header second",
        item1: "15% Descuento  de 2 a 5 personas ",
        item2: "30% Descuento para más de 5 personas",
        item3:
          "El método de inscripción, pago y facturación, se hará directamente a través del correo atencioncongresistas@colegiomontetabor.es. A través del correo también se les pedirá rellenar un formulario por asistente, donde podrá elegir los talleres a los que asistir. El aforo de los talleres es limitado así que se asignarán las plazas en estricto orden de inscripción. En caso de haber elegido uno ya lleno, se le comunicará vía correo electrónico con la propuesta de talleres que no se hayan llenado.",
      },
      /* 

Si eres una institución educativa y quieres inscribir a varias personas, te informamos que ofrecemos dos tipos de descuento: de 2 a 5 personas un 15% y más de 5 personas un 30%. 
El método de inscripción, pago y facturación, se hará directamente a través del correo atencioncongresistas@colegiomontetabor.es.   
A través del correo también se les pedirá rellenar un formulario por asistente, donde podrá elegir los talleres a los que asistir. El aforo de los talleres es limitado así que se asignarán las plazas en estricto orden de inscripción. En caso de haber elegido uno ya lleno, se le comunicará vía correo electrónico con la propuesta de talleres que no se hayan llenado. 

      {
        title: "ENTRADA Y HOTEL",
        subtitle: "Congreso + 1 noche",
        price: "250",
        zoho_url:
          "https://zohosecurepay.eu/checkout/gzxem12s-3kjozgmfus148/Entrada-y-hotel",
        table_class: "pricingTable-header second",
        item1: "Toda la participación del congreso",
        item2: "1 noche de hotel (noche del viernes).",
        item3: "Desayuno en el hotel e impuestos incluidos. ",
        item4:
          "* Los precios son para uso individual, si se comparte habitación habrá que pagar un suplemento de 10€/noche. ",
        item5: "·",
        item6: "·",
        item7: "·",
        item8: "·",
      },
      {
        title: "ENTRADA Y HOTEL",
        subtitle: "Congreso + 2 noches",
        price: "350",
        zoho_url:
          "https://zohosecurepay.eu/checkout/gzxem12s-3kjozgmfus148/Entrada-y-hotel",
        table_class: "pricingTable-header second",
        item1: "Toda la participación del congreso",
        item2: "2 noches de hotel (noche del jueves y viernes).",
        item3: "Desayuno en el hotel e impuestos incluidos. ",
        item4:
          "* Los precios son para uso individual, si se comparte habitación habrá que pagar un suplemento de 10€/noche. ",
        item5: "·",
        item6: "·",
        item7: "·",
        item8: "·",
        description: "Desayuno e impuestos incluidos",
      }, */
    ];

    return (
      <React.Fragment>
        <MainBanner />

        <section className="pricing-area ptb-120 bg-image">
          <div className="container">
            <h2>Forma de inscripción</h2>
            <h6 style={{ marginBottom: "40px" }}>
              Tenemos dos modalidades de inscripción: para particulares y para
              grupos de instituciones educativas.
              <br />
              <br />
              En el caso de los participantes particulares el procedimiento de
              inscripción comienza con la realización del pago y, después, se le
              solicitará que rellene un formulario especificando los talleres y
              otros datos para personalizar su inscripción. <br />
              <br />
              El aforo de los talleres es limitado así que se asignarán las
              plazas en estricto orden de inscripción. En caso de haber elegido
              uno ya lleno, se le comunicará vía correo electrónico con la
              propuesta de talleres que no se hayan llenado. <br />
              <br />
              Para cualquier aclaración, pueden escribir a &nbsp;
              <a href="mailto:atencioncongresistas@colegiomontetabor.es">
                atencioncongresistas@colegiomontetabor.es
              </a>
            </h6>

            {/* <h4>1. Normal (V14-S15)</h4>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSe3SdFbeCRPBr5YHILZbal3SuhyDGOT6TdUJ6nPm9bq83FxAg/viewform?usp=send_form">
                Formulario de inscripción
              </a>{" "}
              + Pago (elija la opción que proceda abajo, con o sin hotel)
            <h4>2. Solo Sábado 15</h4>
            <h6>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSdTPWV0CisZPAdsEj_lYcVQg-ZIb9uwFV2frwY5G8kuVqBltQ/viewform">
                Formulario de inscripción sábado 15
              </a>{" "}
              + Pago (solo sábado 15)
            </h6>
            <h4>
              3. Colegios pertenecientes a la Red, que participan en la Semana
              Internacional, a través de la Fundación Pentecostés.
            </h4>

            <p>
              Para poder garantizar todos los servicios ofertados necesitamos
              que rellene el formulario de inscripción. El registro de datos y
              la reserva de plaza quedan condicionados a la realización del
              pago.
              <br />
              <strong style={{ "margin-bottom": "50px" }}>
                Para cualquier aclaración, puede escribir a
                atencioncongresistas@colegiomontetabor.es
              </strong>
            </p> */}
            <div className="row">
              {inscripciones.map((inscripcion) => (
                <div className=" col-md-4">
                  <div className="pricing-table-box">
                    <div className={inscripcion.table_class}>
                      <h3 className="title">{inscripcion.title}</h3>
                      <h3 className="subtitle">{inscripcion.subtitle}</h3>
                      <div className="price-value">
                        {inscripcion.price}
                        {inscripcion.price ? <sup>€</sup> : <sup> · </sup>}
                      </div>
                    </div>

                    <ul
                      className="pricing-content"
                      style={{ padding: "0px 10px 20px" }}
                    >
                      <li>{inscripcion.item1}</li>
                      <li>{inscripcion.item2}</li>
                      <li>{inscripcion.item3}</li>

                      {inscripcion.title === "ENTRADA CONGRESO" && (
                        <>
                          <li>{inscripcion.item4}</li>
                          <li>{inscripcion.item5}</li>
                          <li>{inscripcion.item6}</li>
                          <li>{inscripcion.item7}</li>
                        </>
                      )}
                      {/*                       <li>{inscripcion.item8}</li> */}
                    </ul>

                    {inscripcion.zoho_url && (
                      <div className="button-box">
                        <a
                          href={inscripcion.zoho_url}
                          rel="noopener noreferrer"
                          target="_blank"
                          className="btn btn-primary"
                        >
                          Inscríbete
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <Footer />
      </React.Fragment>
    );
  }
}

export default Pricing;
